// "Ocultar valores" do módulo RH (o botão de olho do Apps Script): esconde os valores em R$ das telas
// de consulta para quem está com a tela compartilhada/projetada. Formulários continuam mostrando o
// que está sendo digitado. A escolha fica no navegador e vale para todas as telas do RH.
import { useSyncExternalStore } from "react";
import { formatBRL } from "../estoque/ui";

const CHAVE = "rh_valores_ocultos";
const ouvintes = new Set();

function ler() {
  try {
    return localStorage.getItem(CHAVE) === "1";
  } catch {
    return false;
  }
}

let ocultos = ler();

export function alternarValoresOcultos() {
  ocultos = !ocultos;
  try {
    localStorage.setItem(CHAVE, ocultos ? "1" : "0");
  } catch {
    // sem localStorage (aba anônima): vale só até recarregar
  }
  ouvintes.forEach((f) => f());
}

function assinar(f) {
  ouvintes.add(f);
  return () => ouvintes.delete(f);
}

export function useValoresOcultos() {
  return useSyncExternalStore(assinar, () => ocultos);
}

/** formatBRL que respeita o "ocultar valores". */
export function useFormatValor() {
  const oculto = useValoresOcultos();
  return oculto ? () => "R$ •••••" : formatBRL;
}
